export default "__VITE_ASSET__e35944ef__"